import { Injectable } from '@angular/core';
import { DialogService } from '../../app/features/shared/services/dialog.service';
import {
  CreateFolderDialogInput,
  CreateFolderDialogResult,
  CreateFolderDialogComponent,
} from './components/create-folder-dialog/create-folder-dialog.component';
import {
  RenameFolderDialogInput,
  RenameFolderDialogResult,
  RenameFolderDialogComponent,
} from './components/rename-folder-dialog/rename-folder-dialog.component';
import {
  SelectFolderDialogComponent,
  SelectFolderDialogInput,
  SelectFolderDialogResult,
} from './components/select-folder-dialog/select-folder-dialog.component';
import {
  SelectFoldersDialogComponent,
  SelectFoldersDialogInput,
  SelectFoldersDialogResult,
} from './components/select-folders-dialog/select-folders-dialog.component';

@Injectable()
export class StorageDialogService {
  constructor(private dialog: DialogService) {}

  public readonly openCreateFolder = this.dialog.createOpenDialogFn<
    CreateFolderDialogInput,
    CreateFolderDialogResult
  >(CreateFolderDialogComponent);

  public readonly openRenameFolder = this.dialog.createOpenDialogFn<
    RenameFolderDialogInput,
    RenameFolderDialogResult
  >(RenameFolderDialogComponent);

  public readonly openSelectFolderDialog = this.dialog.createOpenDialogFn<
    SelectFolderDialogInput,
    SelectFolderDialogResult
  >(SelectFolderDialogComponent, {
    maxWidth: '700px',
  });

  public readonly openSelectFoldersDialog = this.dialog.createOpenDialogFn<
    SelectFoldersDialogInput,
    SelectFoldersDialogResult
  >(SelectFoldersDialogComponent, {
    maxWidth: '700px',
  });
}
